// extracted by mini-css-extract-plugin
export var active = "_75-a";
export var activeIndicator = "_75-9";
export var disabled = "_75-b";
export var fullWidth = "_75-2";
export var lg = "_75-7";
export var md = "_75-6";
export var redoButtonTabGroup = "_75-0";
export var sm = "_75-5";
export var tabButton = "_75-4";
export var tabButtonsContainer = "_75-1";
export var themeDestructive = "_75-d";
export var themeNormal = "_75-c";
export var themeSuccess = "_75-e";
export var xl = "_75-8";
export var xs = "_75-3";